export default "__VITE_ASSET__11036686__"